import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

const useScroll = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const { minScrollHeight } = useSelector((store) => store.layout);

  useEffect(() => {
    let ticking = false;

    const handleScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          const scrollTop = window.scrollY || document.documentElement.scrollTop;
          const scroll = scrollTop > minScrollHeight;

          setIsScrolled(prev => (prev !== scroll ? scroll : prev));

          ticking = false;
        });

        ticking = true;
      }
    };

    window.addEventListener('scroll', handleScroll, { passive: true });

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [minScrollHeight]);

  return { isScrolled };
};

export default useScroll;